module.exports = __webpack_public_path__ + "static/media/nativlab-logo.100c2cf2.png";